<template>
  <div class="page-class page-center">
    <div class="page-staff-form">
      <h1 class="page-title text-center">{{ title }}</h1>
      <user-form-box
        list-url="/user"
        user-type="user"
        :form-type="formType"
        :mobile="mobile"
        @add="onAdd"
        @edit="onEdit"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import UserFormBox from '@/components/UserFormBox.vue';
import router from '@/router';

export default {
  name: 'UserForm',
  components: {
    UserFormBox
  },
  async mounted() {
    if (this.$route.name === 'user-new') {
      this.formType = 'new';
      this.mobile = null;
    } else {
      this.formType = 'update';
      this.mobile = parseInt(this.$route.params.id, 10);
      await this.getOne({
        type: 'user',
        mobile: this.mobile,
        router
      });
    }
  },
  data() {
    return {
      formType: '',
      mobile: null
    };
  },
  computed: {
    title() {
      return this.formType === 'new' ? 'Add new user' : 'Update user';
    },
    ...mapState('user', ['loading', 'availableRoles'])
  },
  methods: {
    ...mapActions('user', ['getOne', 'postOne', 'patchOne']),
    onAdd({ user }) {
      this.postOne({
        type: 'user',
        user,
        router,
        redirectUrl: '/user'
      });
    },
    onEdit({ user }) {
      this.patchOne({
        type: 'user',
        mobile: this.mobile,
        user,
        router,
        redirectUrl: '/user'
      });
    }
  }
};
</script>
